<div class="rotate-device" *ngIf="scenario && scenario.settings && scenario.settings.showRotateMessage">
  <div class="phone"></div>
  <div class="message" *ngIf="scenario.settings.showRotateMessageText">
    {{ scenario.settings.showRotateMessageText }}
  </div>
</div>
<div class="player-bg" style="{{contentService.hasWindowBg(content, scenario) ? 'background-color: var(--ys-bg)' : null}}"></div>
<div *ngIf="content" [ngStyle]="contentService.hasWindowBg(content, scenario) ? contentService.getCanvasStyle(content, scenario.style, scenario?.settings?.canvas) : null"
  style="width: 100%; height: 100%; position: absolute; top: 0; left: 0" class="scenario-{{ scenario.id }}"
  id="ys-player" #ysplayer aria-live="polite" (contextmenu)="onContextMenu($event)">
  <div *ngIf="
      ((content?.canvas?.style?.bg || content?.canvas?.style?.bgGradient) || !content?.canvas?.style?.bgImage && scenario.style.bgColor) &&  
     contentService.hasWindowBg(content, scenario)
    "
    style="width:100%;height:100%;position:absolute;top:0;left:0;background:{{content.canvas.style.bgGradient ? contentService.buildGradientString(content.canvas.style.bgGradient) : ( content.canvas.style.bg ? content.canvas.style.bg : 'var(--ys-bg)')}}">
  </div>



  <div class="step-content-container" id="step-content-container" style="transform: translate(-50%, -50%) scale({{ scale }}); width:{{scenario.settings.canvas.width}}px; height:{{ scenario.settings.canvas.height }}px; --ys-step-bg:{{content?.canvas?.style?.bgGradient ? contentService.buildGradientString(content?.canvas?.style?.bgGradient) : ( content?.canvas?.style?.bg ? content?.canvas?.style?.bg : scenario.style.bgColor)}}" *ngIf="scale && animsComplete" #stepContentContainer  [ngStyle]="contentService.hasStepBg(content, scenario) ? contentService.getCanvasStyle(content, scenario.style, scenario?.settings?.canvas) : null"
    [ngClass]="{'has-bg':((content?.canvas?.style?.bgFit =='step') || (scenario.style.bgFit =='step' && !content?.canvas?.style?.bg))}">
    <div class="countdown-clock" *ngIf="activeCountdown" style="z-index: 10000000">
      {{ activeCountdownClock }}
    </div>
    <app-user-tracking-form [scenario]="scenario" *ngIf="
        !userDataSet &&
        scenario.settings.tracking &&
        scenario.settings.tracking.method == 'form' &&
        scenario.settings.tracking.fields
      "></app-user-tracking-form>

      <ng-container *ngIf="showInventory && scenario.style.inventoryLayout && scenario.style.inventoryLayout=='inline'">
        <app-inventory [scenario]="scenario"></app-inventory>
      </ng-container>

    <div class="global-content" *ngIf="!step?.content?.config?.hideGlobalComponent">
      <app-global-components [scenario]="scenario" [content]="layoutContent" [scale]="scale"
        style="z-index: 99999; position: absolute; top: 0; left: 0"></app-global-components>
    </div>

    <div *ngIf="canvasAnimationStyle || canvasOverflow || canvasDimensions"
      class="step-content {{ canvasAnimationClass }}" [attr.style]="
        canvasAnimationStyle + '; ' + canvasOverflow + '; ' + canvasDimensions
      ">
      <ng-container *ngFor="let component of this.content.components">
        <ng-container *ngIf="component.draggable">
          
          <div id="component-drag-{{ component.id }}" class="component-drag" cdkDrag
            [cdkDragLockAxis]="component.dragLockAxis ? component.dragLockAxis : null"
            [cdkDragBoundary]="component.dragBoundary ? (component.dragBoundary == 'canvas' ? '#step-content-container' : '#component-container-ys-' + component.dragBoundary) : ''"
            (cdkDragStarted)="onDragStarted($event, component)" (cdkDragMoved)="onDragMove($event, component)"
            (cdkDragEnded)="onDragEnd($event, component)" [cdkDragDisabled]="component?.disableDrag"
            style="position:absolute;width:{{ component.width }}px;height:{{
              component.height
            }}px;top:{{ component.pos.y }}px;left:{{
              component.pos.x
            }}px;z-index:{{  !statesService.getComponentState(component) ? component.style.zIndex : statesService.getComponentState(component).style.zIndex }};"
            [hidden]="playerService.getComponentHidden(component, content)">
            <app-component-container [component]="component" [content]="content" [scenario]="scenario"
              [disableVideo]="disableVideo" [disableAudio]="disableAudio" [muted]="muted" [step]="step"
              [scale]="scale"></app-component-container>
          </div>

        </ng-container>
        <ng-container *ngIf="!component.draggable">
          <app-component-container [scale]="scale" [component]="component" [content]="content" [scenario]="scenario"
            [disableVideo]="disableVideo" [disableAudio]="disableAudio" [muted]="muted"
            [step]="step"></app-component-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>